<div class="bom-table__wrapper">
  <table class="lum-table lum-table--classic striped">
    <tr class="table__head-row">
      <th>ID</th>
      <th>Name</th>
      <th></th>
    </tr>
    <tbody>
      <tr *ngFor="let row of data; trackBy: trackById; let i = index">
        <td>{{ row.id }}</td>
        <td>
          <a [routerLink]="['/bom/view/', row.id]">{{ row.name }}</a>
        </td>
        <td class="flex justify-end position-sticky" style="right: 0">
          <button
            mat-icon-button
            [matMenuTriggerFor]="menuActions"
            (click)="$event.stopPropagation()"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
        <mat-menu #menuActions="matMenu">
          <button [routerLink]="['/bom/view/', row.id]" mat-menu-item>
            <i class="fa fa-eye"></i> View
          </button>
          <button [routerLink]="['/bom/edit/', row.id]" mat-menu-item>
            <i class="fas fa-edit"></i> Edit
          </button>
          <button
            class="text-danger"
            (click)="deleteEvent.emit(row.id)"
            mat-menu-item
          >
            <i class="fas fa-trash"></i> Delete
          </button>
        </mat-menu>
      </tr>
    </tbody>
  </table>
</div>
